import Vue from "vue";

export async function show(id) {
  const response = await Vue.prototype.$http.get(`/text-templates/${id}`);

  return response.data;
}

export async function update(id, payload) {
  const response = await Vue.prototype.$http.put(
    `/text-templates/${id}`,
    payload
  );

  return response.data;
}

export async function preview(id, payload) {
  const response = await Vue.prototype.$http.post(
    `/text-templates/${id}/preview`,
    payload
  );

  return response.data;
}
